import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getLocations = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/locations`);
  return data;
});

export const getLocation = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`salon/locations/${id}`);
  return data;
});
export const updateLocation = catchAsync(async (body) => {
  const data = await axiosInstance.put(`salon/locations/${body.id}`, body);
  return data;
});
export const addLocation = catchAsync(async (body) => {
  const data = await axiosInstance.post(`salon/locations`, body);
  return data;
});
export const getTaxes = catchAsync(async (params,translations) => {
  const { data } = await axiosInstance.get(`salon/taxes-groups`, {
    params,
    headers: {
      "x-translations": translations,
    }, });
  return data;
});
export const getLoyalty = catchAsync(async (id, params,) => {
  const { data } = await axiosInstance.get(`salon/loyalty-programs`, {
    params,
    });
  return data;
});
export const getPayments = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/payment-methods`,{
    headers: {
      "x-translations": true,
    },
  });
  return data;
});
export const updatePayments = catchAsync(async (body) => {
  const data = await axiosInstance.put(`salon/payment-methods/${body?.id}`,body);
  return data;
});
export const addLoyaltyProgram = catchAsync(async (body) => {
  const data = await axiosInstance.post(`salon/loyalty-programs`,body);
  return data;
});
export const updateLoyaltyProgram = catchAsync(async (body) => {
  const { data } = await axiosInstance.put(`salon/loyalty-programs/${body.id}`,body);
  return data;
});
export const deleteLoyaltyProgram = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`salon/loyalty-programs/${id}`);
  return data;
});
export const deletePayments = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`salon/payment-methods/${id}`);
  return data;
});
export const addPayments = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(`salon/payment-methods`,body);
  return data;
});
export const getTax = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`salon/taxes/${id}`);
  return data;
});
export const updateTax = catchAsync(async (body) => {
  const { data } = await axiosInstance.put(`salon/taxes/${body.id}`, body);
  return data;
});
export const addTax = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(`salon/taxes`, body);
  return data;
});
export const deleteTax = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`salon/taxes/${id}`);
  return data;
});

export const updateSalon = catchAsync(async (body) => {
  const data = await axiosInstance.put(`salon/salon-profiles/${body.id}`, body);
  return data;
});
export const getSalon = catchAsync(async (id, xTranslate = false) => {
  const { data } = await axiosInstance.get(`salon/salon-profiles/${id}`, {
    headers: {
      "x-translations": xTranslate,
    },
  }); // youse id required
  return data;
});
export const addSuppliers = catchAsync(async (body) => {
  const data = await axiosInstance.post(`salon/suppliers`, body);
  return data;
});
export const getSuppliers = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/suppliers");
  return data;
});
export const addClosedPeriods = catchAsync(async (body) => {
  const data = await axiosInstance.post(`salon/closed-periods`, body);
  return data;
});
export const getClosedPeriods = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/closed-periods");
  return data;
});
export const updateClosedPeriods = catchAsync(async (body) => {
  const { data } = await axiosInstance.put(
    `salon/closed-periods/${body.id}`,
    body
  );
  return data;
});
export const deleteClosedPeriod = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`salon/closed-periods/${id}`);
  return data;
});
export const addPromoCodes = catchAsync(async (body) => {
  const data = await axiosInstance.post("salon/promo-codes", body);
  return data;
});
export const getPromoCodes = catchAsync(async (body) => {
  const { data } = await axiosInstance.get("salon/promo-codes", body);
  return data;
});
export const deletePromoCodes = catchAsync(async (id) => {
  const data = await axiosInstance.delete(`salon/promo-codes/${id}`);
  return data;
});
export const putPromoCodes = catchAsync(async (body) => {
  const data = await axiosInstance.put(`salon/promo-codes/${body.id}`, body);
  return data;
});
export const deleteReview = catchAsync(async (locationId, ratId) => {
  const { data } = await axiosInstance.delete(
    `salon/locations/${locationId}/ratings/${ratId}`
  );
  return data;
});
export const getSettingsClient = catchAsync(async (locationId, params) => {
  const { data } = await axiosInstance.get(
    `salon/${locationId}/client-setting`,
    {
      params,
    }
  );
  return data;
});
export const addNewSettingsClient = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(`salon/update/settings`, body);
  return data;
});
export const getPaymentMethods = catchAsync(async (locationId, params) => {
  const { data } = await axiosInstance.get(`salon/payment-methods`, {
    params,
  });
  return data;
});
